export default __webpack_public_path__ + "static/media/steep2_logo.c605dd62.png";